import React, { Component } from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import { connect } from "react-redux";

// core components
import CardFooter from "components/Card/CardFooter.jsx";
import Button from "components/CustomButtons/Button.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import withMobileDialog from "@material-ui/core/withMobileDialog";
import dashboardStyle from "assets/jss/material-dashboard-react/views/dashboardStyle.jsx";
import { alertActions, commonActions } from "../../_actions";
import { EmptyRecord } from "../../utils/PageUtility";
import { commonService } from "../../_services";
import { appConstants } from "../../_constants";
import CircularProgress from '../../utils/CircularProgress';
import { appHelpers } from "../../_helpers";
import AddRecordModal from "./AddRecordModal";
import PdmPanel from "./PdmPanel";
import PdmTable from "./PdmTable";
import ViewMore from "./ViewMore";
import EditPdm from "./EditPdm";

// @material-ui/icons
import DownloadIcon from "@material-ui/icons/CloudDownload";


const statusTypes = [
    { name: "All Status", value: "-1" },
    { name: "Pending Data", value: 0 },
    { name: "Incomplete Data", value: 1 },
    { name: "Complete Data", value: 2 }
];

const panelStatusTypes = [
    { name: "All Status", value: "-1" },
    { name: "Pending", value: 0 },
    { name: "Partial", value: 1 },
    { name: "Complete", value: 2 }
]

const today = new Date();
let aMonthAgo = new Date();
aMonthAgo.setDate(today.getDate() - 30);

class Pdm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
            open: false,
            airlines: [],
            requestingPdm: true,
            flightNumbers: [],
            flightNumber: '-1',
            locationData: [],
            locationId: '-1',
            destinationData: [],
            destinationId: '-1',
            passengerCount: '',
            addAirlineId: '-1',
            formError: '',
            airlineError: false,
            error: false,
            flightError: false,
            locationError: false,
            passengerCountError: false,
            billablePaxError: false,
            flightDate: new Date(),
            destinationError: false,
            airlineName: '',
            AirlineId: '-1',
            Status:  '-1',
            searchFlightNumbers: [],
            searchFlightNumber: '-1',
            searchLocationId: '-1',
            searchDestinationId: '-1',
            billablePaxCount: '',
            startDate: aMonthAgo,
            endDate: today,
            pdmData: [],
            currentPage: 1,
            totalCount: 0,
            pageSize: 10,
            isViewMoreOpen: false,
            getMoreData: [],
            isEditModalOpen: false,
            newAirlineId: '-1',
            editFlightNumbers: [],
            newFlightNumber: '-1',
            newFlightDate: new Date(),
            newLocationId: '-1',
            newDestinationId: '-1',
            newPassengerCount: '',
            newBillablePaxCount: '',
            pendingPdmId: '',
            pdmId: '',
            users: [],
            user: "",
            billablePaxError2: false
        }
    }

    componentDidMount() {
        const { airports, user, dispatch, airlines, users } = this.props;
        let { pageSize, startDate, endDate } = this.state;

        if (airports) {
            this.setState({ destinationData: airports, locationData: airports })
        } else {
            dispatch(commonActions.getAllAirports())
        }

        if (airlines) {
            this.setState({ airlineData: airlines })
        } else {
            dispatch(commonActions.getAllAirlines())
        }

        if (users) {
            this.setState({ users: users.ResultList })
        } else {
            dispatch(commonActions.getAllUsers())
        }
        //THIS BLOCK OF COMMENTED CODE MIGHT BE NEEDED LATER.
        // if(user.AppRole === appConstants.ROLES.AIRLINE) {
        //     this.setState({addAirlineId: user.AirlineId, AirlineId: user.AirlineId})
        //     let payload = {
        //         StartDate: startDate,
        //         EndDate: endDate,
        //         From: 1,
        //         Size: pageSize,
        //         AirlineId: user.AirlineId
        //     };
        //     console.log('addAirlineId', user.AirlineId);
        //     this.fetchAirlineFlightNumbers(user.AirlineId, 'flightNumbers');
        //     this.searchPdm( payload);
        // }
        if (user.AppRole === appConstants.ROLES.AIRPORT_MANAGER) {
            let userObj = { ...user };
            let userLocation = { value: userObj.AirportCode, label: userObj.Location };
            this.setState({ searchLocationId: userLocation, locationId: userLocation });
            let payload = {
                StartDate: startDate,
                EndDate: endDate,
                From: 1,
                Size: pageSize,
                DepartureLocation: user.AirportCode
            };
            this.searchPdm(1, payload)

        } else if (user.Location) {
            let userObj = { ...user };
            let userLocation = { value: userObj.AirportCode, label: userObj.Location };
            this.setState({ searchLocationId: userLocation, locationId: userLocation });
            let payload = {
                StartDate: startDate,
                EndDate: endDate,
                From: 1,
                Size: pageSize,
                DepartureLocation: user.AirportCode
            };
            this.searchPdm(1, payload)

        } else {
            this.searchPdm(1);
        }
    }

    componentWillReceiveProps = function (nextProps) {
        const { airlines, users, user, airports } = nextProps;
        if (airlines) {
            let modifiedAirlines = [...airlines];
            let allAirlines = { Airline: "All Airlines", AirlineId: "-1" };
            modifiedAirlines.unshift(allAirlines);
            this.setState({ airlines: modifiedAirlines });
        }
        if (users) {
            this.setState({ users: users.ResultList });
        }
        if (user) {
            this.setState({ user: user.userId });
        }
        if (airports) {
            let modifiedAirports = [...airports];
            modifiedAirports.unshift({ Name: "All Airports", AirportCode: "-1" });
            this.setState({ destinationData: modifiedAirports, locationData: modifiedAirports })
        }
    };

    handleDateChange = (date, target) => {
        this.setState({ [target]: date });
    };

    selectChange = event => {
        this.setState({ [event.target.name]: event.target.value });

        if (event.target.name === 'addAirlineId') {
            // console.log('event.target.name', event.target.name)
            // this.setState({flightNumbers: []});

            this.fetchAirlineFlightNumbers(event.target.value, 'flightNumbers');
        }
        if (event.target.name === 'newAirlineId') {
            this.fetchAirlineFlightNumbers(event.target.value, 'editFlightNumbers');
        }
        if (event.target.name === "AirlineId") {
            this.fetchAirlineFlightNumbers(event.target.value, 'searchFlightNumbers')
        }


    };

    handleReactSelectChange = (value, name) => {
        this.setState({ [name.name]: value });
        if (value.value === undefined || value.value === "-1" || value.value === "All Flights") {
            this.setState({ [name.name]: "-1" })
        }

        if (name.name === 'addAirlineId') {
            // console.log('event.target.name', event.target.name)
            // this.setState({flightNumbers: []});

            this.fetchAirlineFlightNumbers(value.value, 'flightNumbers');
        }
        if (name.name === 'newAirlineId') {
            this.fetchAirlineFlightNumbers(value.value, 'editFlightNumbers');
        }
        if (name.name === "AirlineId") {
            this.fetchAirlineFlightNumbers(value.value, 'searchFlightNumbers')
        }

    };

    //Get flight Numbers on select of airline by passing the airlineId
    fetchAirlineFlightNumbers = (airlineId, stateValue) => {
        // console.log('stateValue', stateValue);
        const { dispatch } = this.props;
        dispatch(alertActions.startRequest());
        commonService.getAirlinesFlightNumbers(airlineId)
            .then((res) => {
                dispatch(alertActions.stopRequest());
                let response = res.response;
                if (res.status === appConstants.SUCCESS_RESPONSE) {
                    // this.setState({ flightNumbers: response.Results , searchFlightNumbers: response.Results});
                    let modifiedFlights = [...response.Results];
                    modifiedFlights.unshift({ FlightNumber: "All Flights" });
                    this.setState({ [stateValue]: modifiedFlights });
                }
                else if (res.status === appConstants.ERROR_RESPONSE) {
                    dispatch(alertActions.error(res.response));
                }
            });
    };


    // add new pdm
    handleSubmit = () => {

        let { addAirlineId, flightNumber, flightDate,
            locationId, passengerCount, destinationId, billablePaxCount,
        } = this.state;

        flightDate = appHelpers.formatDateSpecific(flightDate, "YYYY-MM-DD");

        const { user, dispatch } = this.props;

        if (addAirlineId === "" || addAirlineId === "-1") {
            this.setState({ airlineError: true })
        } else {
            this.setState({ airlineError: false })
        }

        if (flightNumber === "" || flightNumber === "-1") {
            this.setState({ flightError: true })
        } else {
            this.setState({ flightError: false })
        }

        if (locationId === "" || locationId === "-1") {
            this.setState({ locationError: true })
        } else {
            this.setState({ locationError: false })
        }

        if (passengerCount === "") {
            this.setState({ passengerCountError: true })
        } else {
            this.setState({ passengerCountError: false })
        }

        if (destinationId === "" || destinationId === "-1") {
            this.setState({ destinationError: true })
        } else {
            this.setState({ destinationError: false })
        }

        if (billablePaxCount === "") {
            this.setState({ billablePaxError: true })
        } else {
            this.setState({ billablePaxError: false })
        }

        if (billablePaxCount > passengerCount) {
            this.setState({ billablePaxError2: true });
        }

        if (addAirlineId === "" || addAirlineId === "Placeholder" || flightNumber === "" || flightNumber === "-1" ||
            locationId === "" || locationId === "-1" || passengerCount === "" ||
            destinationId === "" || destinationId === "-1" || billablePaxCount === "") {
            return
        }

        const payload = {
            AirlineId: addAirlineId.value,
            FlightNo: flightNumber.value,
            DepartureDate: flightDate,
            DepartureLocation: locationId.value,
            PassengerCount: passengerCount,
            DestinationLocation: destinationId.value,
            BillablePassengerCount: billablePaxCount,
            CreatedBy: user.userId,
        }
        // console.log('payload', payload)
        dispatch(alertActions.startRequest());

        commonService.savePdm(payload)
            .then((res) => {
                // console.log('res', res);
                dispatch(alertActions.stopRequest());
                if (res.status === appConstants.SUCCESS_RESPONSE) {
                    dispatch(alertActions.notify('Data Added Successfully'));
                    this.handleCloseModal();
                    this.searchPdm();
                    this.resetForm();
                }
                else if (res.status === appConstants.ERROR_RESPONSE) {
                    dispatch(alertActions.error(res.response));
                    this.setState({
                        formError: res.response,
                        error: true,
                        addingDataEntry: false
                    });
                }
            })
    };


    // update pdm
    handleUpdate = (pdmId) => {
        // console.log('pdm', pdmId);

        const { newAirlineId, newFlightNumber, newFlightDate, newPassengerCount, newBillablePaxCount,
            newDestinationId, newLocationId } = this.state;
        const { user, dispatch } = this.props;
        // console.log('newBillablePax', newBillablePaxCount);

        let departureDate = appHelpers.formatDateSpecific(newFlightDate, "YYYY-MM-DD");


        if (newAirlineId === "" || newAirlineId === "Placeholder") {
            this.setState({ airlineError: true })
        } else {
            this.setState({ airlineError: false })
        }

        if (newFlightNumber === "" || newFlightNumber === "-1" || newFlightNumber === "All Flights") {
            this.setState({ flightError: true })
        } else {
            this.setState({ flightError: false })
        }

        if (newLocationId === "" || newLocationId === "-1") {
            this.setState({ locationError: true })
        } else {
            this.setState({ locationError: false })
        }

        if (newDestinationId === "" || newDestinationId === "-1") {
            this.setState({ destinationError: true })
        } else {
            this.setState({ destinationError: false })
        }

        if (newPassengerCount === "") {
            this.setState({ passengerCountError: true })
        } else {
            this.setState({ passengerCountError: false })
        }

        if (newBillablePaxCount === "") {
            this.setState({ billablePaxError: true })
        } else {
            this.setState({ billablePaxError: false })
        }

        if (newBillablePaxCount > newPassengerCount) {
            this.setState({ billablePaxError2: true });
        }

        if (newAirlineId === "" || newAirlineId === "Placeholder" || newFlightNumber === "" || newFlightNumber === "-1" ||
            newPassengerCount === "" || newBillablePaxCount === "") {
            return
        }

        const payload = {
            Id: pdmId,
            AirlineId: newAirlineId,
            FlightNo: newFlightNumber,
            DepartureDate: departureDate,
            DepartureLocation: newLocationId,
            DestinationLocation: newDestinationId,
            BillablePassengerCount: newBillablePaxCount,
            PassengerCount: newPassengerCount,
            CreatedBy: user.userId
        };

        // console.log('update payload ', payload);
        dispatch(alertActions.startRequest());

        commonService.savePdm(payload)
            .then((res) => {
                dispatch(alertActions.stopRequest());
                if (res.status === appConstants.SUCCESS_RESPONSE) {

                    dispatch(alertActions.notify("Update Successful"));
                    this.closeEditModal();
                    this.searchPdm();
                }
                else if (res.status === appConstants.ERROR_RESPONSE) {
                    dispatch(alertActions.error(res.response));
                    this.setState({
                        formError: res.response,
                        error: true,
                        requestingPdm: false
                    });
                }
            })
    };


    //search user-created PDM with parameters
    searchPdm = (pageNumber = 1, payload) => {
        let { AirlineId, pageSize, startDate, endDate, searchLocationId,
            searchDestinationId, searchFlightNumber, Status } = this.state;
        const { dispatch } = this.props;

        startDate = appHelpers.formatDateSpecific(startDate, "YYYY-MM-DD");
        endDate = appHelpers.formatDateSpecific(endDate, "YYYY-MM-DD");

        if (!payload) {
            payload = {
                StartDate: startDate,
                EndDate: endDate,
                From: pageNumber,
                Size: pageSize,
                // CreatedBy: user.userId,
                // Status: status
                // FlightNo: searchFlightNumber,
                // DepartureLocation: searchLocationId,
                // DestinationLocation: searchDestinationId,
            };

            if (AirlineId !== "-1") {
                payload.AirlineId = AirlineId.value
            }
            if (searchFlightNumber !== "-1" && searchFlightNumber !== "All Flights") {
                payload.FlightNo = searchFlightNumber.value
            }
            if (searchLocationId !== "-1") {
                payload.DepartureLocation = searchLocationId.value
            }
            if (searchDestinationId !== "-1") {
                payload.DestinationLocation = searchDestinationId.value
            }
            if (Status !== "-1") {
                payload.Status = Status.value
            }
        }

        dispatch(alertActions.startRequest());
        commonService.searchPdm(payload)
            .then((res) => {
                dispatch(alertActions.stopRequest());
                let response = res.response;
                if (res.status === appConstants.SUCCESS_RESPONSE) {
                    this.setState({
                        currentPage: pageNumber,
                        totalCount: response.TotalCount,
                        pdmData: response.Pdm,
                        requestingPdm: false
                    })
                }
                else if (res.status === appConstants.ERROR_RESPONSE) {
                    // console.log('there was an error');
                    dispatch(alertActions.error(res.response));
                    this.setState({ requestingPdm: false });
                }
            })
        this.setState({ flightNumbers: [] })
    };

    handleOpenModal = () => {
        this.setState({ isOpen: true, error: false })
    };

    // close add pdm modal
    handleCloseModal = () => {
        this.setState({
            isOpen: false,
            airlineError: false,
            locationError: false,
            destinationError: false,
            passengerCountError: false,
            flightNumberError: false,
            billablePaxError: false,
            billablePaxError2: false

        });
        this.resetForm()
    };

    resetForm = () => {
        const { locationId } = this.state;
        const { user } = this.props;
        const locationId_ = (user.AppRole === appConstants.ROLES.AIRPORT_MANAGER) || (user.Location) ? locationId : "";
        this.setState({
            addAirlineId: "", newAirlineId: "", passengerCount: "", locationId: locationId_,
            flightNumber: "", destinationId: "", billablePaxCount: ""
        })
    };

    // method: display name of airlineId
    filterAirlines = (airlineId) => {
        const { airlines } = this.state;
        let airlineName = airlines.find(u => u.AirlineId === airlineId);
        if (airlineName) {
            return `${airlineName.Airline}`
        } else {
            return 'Unknown Airline'
        }
    };

    // display name of statusId
    filterStatus = (statusId) => {
        let status = statusTypes.find(item => item.value === statusId)
        if (status) {
            return `${status.name}`
        } else {
            return 'Unknown Status'
        }
    };

    // method: display name of userId
    filterUsers = (userId) => {
        const { users } = this.state;

        if (users) {
            if (userId === null) {
                return ""
            } else {
                let userName = users.find(u => u.Id === userId);
                if (userName) {
                    return `${userName.FirstName} ${userName.LastName}`
                } else {
                    return 'Unknown User'
                }
            }
        }
    };

    //open edit data entry Modal
    openEditModal = (item) => {
        this.setState({ isEditModalOpen: true })
        this.setState({
            newAirlineId: item.AirlineId,
            newFlightNumber: item.FlightNo,
            newFlightDate: item.DepartureDate,
            newPassengerCount: item.PassengerCount,
            newBillablePaxCount: item.BillablePassengerCount,
            newLocationId: item.DepartureLocationCode,
            newDestinationId: item.DestinationLocationCode,
            pendingPdmId: item.Id
        });

        if (item.AirlineId) {
            // console.log('item', item.AirlineId);
            this.setState({ flightNumbers: [] });
            this.fetchAirlineFlightNumbers(item.AirlineId, 'editFlightNumbers');
        }
        this.setState({ flightNumbers: [] });

    };

    // close edit pdm modal
    closeEditModal = () => {
        this.setState({
            isEditModalOpen: false,
            airlineError: false,
            error: false,
            flightError: false,
            locationError: false,
            destinationError: false,
            passengerCountError: false,
            billablePaxError: false,
            searchFlightNumbers: [],
            flightNumbers: [],
            billablePaxError2: false

        });
    };

    // close comment modal
    closeCommentModal = () => {
        this.setState({
            isCommentModalOpen: false,
            pdmId: "",
            comment: ""
        })
    };

    closeViewMoreModal = () => {
        this.setState({
            isViewMoreOpen: false,
            pdmId: ""
        })
    }

    openViewMoreModal = (item) => {
        // console.log('item', item)
        this.setState({
            // pdmId,
            isViewMoreOpen: true,
            getMoreData: item

        })
    };

    downloadPdm = (type) => {
        const { dispatch } = this.props;
        let { AirlineId, startDate, endDate, searchLocationId,
            searchDestinationId, searchFlightNumber, Status } = this.state;
        startDate = appHelpers.formatDateSpecific(startDate, "YYYY-MM-DD");
        endDate = appHelpers.formatDateSpecific(endDate, "YYYY-MM-DD");

        const payload = {
            StartDate: startDate,
            EndDate: endDate,
            Type: type
        };

        if (AirlineId !== "-1") {
            payload.AirlineId = AirlineId.value
        }
        if (searchFlightNumber !== "-1") {
            payload.FlightNo = searchFlightNumber.value
        }
        if (searchLocationId !== "-1") {
            payload.DepartureLocation = searchLocationId.value
        }
        if (searchDestinationId !== "-1") {
            payload.DestinationLocation = searchDestinationId.value
        }
        if (Status === "-1") {
            payload.Status = null
        } else {
            payload.Status = Status.value
        }

        dispatch(alertActions.startRequest());
        commonService.downloadPdm(payload)
            .then((res) => {
                dispatch(alertActions.stopRequest());
                let response = res.response
                if (res.status === appConstants.SUCCESS_RESPONSE) {
                    if (response.ErrorMessageList.length > 0) {
                        dispatch(alertActions.error(response.ErrorMessageList.join(', ')));
                        this.setState({ pageRequesting: false });
                    } else {
                        if (response.DownloadUrl !== null) {
                            appHelpers.downloadFile(response.ResponseType.DownloadUrl, "PDM Report");
                        } else {
                            dispatch(alertActions.error(response.Message));
                        }
                    }
                }
                else if (res.status === appConstants.ERROR_RESPONSE) {
                    if (response.ErrorMessageList) {
                        dispatch(alertActions.error(response.ErrorMessageList.join(', ')));
                    }
                    else if (typeof response === 'string') {
                        dispatch(alertActions.error(response));
                    } else {
                        dispatch(alertActions.error("Something went wrong."));
                    }
                    this.setState({ pageRequesting: false });
                }
            });


    }

    render() {
        const { classes, requesting } = this.props;
        const { isOpen, airlines, flightNumbers, flightNumber, locationData, locationId, destinationData,
            destinationId, passengerCount, addAirlineId, formError, airlineError, error,
            flightError, locationError, passengerCountError, billablePaxError, flightDate,
            requestingPdm, destinationError, airlineName, AirlineId, searchFlightNumbers,
            searchFlightNumber, searchLocationId, searchDestinationId, billablePaxCount,
            startDate, endDate, Status, pdmData, currentPage, totalCount, pageSize, isViewMoreOpen,
            getMoreData, isEditModalOpen, newAirlineId, editFlightNumbers, newFlightNumber,
            newLocationId, newDestinationId, newPassengerCount, newBillablePaxCount,
            pendingPdmId, newFlightDate, user, billablePaxError2 } = this.state;

        if (requestingPdm)
            return (
                <CircularProgress />
            );
        return (
            <div>
                <AddRecordModal
                    user={this.props.user}
                    selectChange={this.selectChange}
                    isOpen={isOpen}
                    data={airlines}
                    handleOpenModal={this.handleOpenModal}
                    handleSubmit={this.handleSubmit}
                    handleClose={this.handleCloseModal}
                    flightNumbers={flightNumbers}
                    flightNumber={flightNumber.value}
                    locationData={locationData}
                    locationId={(this.props.user.AppRole === appConstants.ROLES.AIRPORT_MANAGER) || (this.props.user.Location) ? locationId : locationId.value}
                    destinationData={destinationData}
                    destinationId={destinationId.value}
                    passengerCount={passengerCount}
                    addAirlineId={addAirlineId.value}
                    formError={formError}
                    airlineError={airlineError}
                    error={error}
                    flightError={flightError}
                    locationError={locationError}
                    destinationError={destinationError}
                    passengerCountError={passengerCountError}
                    billablePaxError={billablePaxError}
                    handleDateChange={this.handleDateChange}
                    flightDate={flightDate}
                    billablePaxError2={billablePaxError2}
                    requesting={requesting}
                    reactSelectChange={this.handleReactSelectChange}
                />
                <PdmPanel
                    user={this.props.user}
                    airline={airlineName}
                    AirlineId={AirlineId.value}
                    Status={Status.value}
                    selectChange={this.handleReactSelectChange}
                    selectAirlineChange={this.selectChange}
                    airlineData={airlines}
                    onSearch={this.searchPdm}
                    startDate={startDate}
                    endDate={endDate}
                    handleDateChange={this.handleDateChange}
                    statusTypes={panelStatusTypes}
                    searchFlightNumbers={searchFlightNumbers}
                    searchLocationData={locationData}
                    searchDestinationData={destinationData}
                    searchFlightNumber={searchFlightNumber}
                    searchLocationId={(this.props.user.AppRole === appConstants.ROLES.AIRPORT_MANAGER) || (this.props.user.Location) ? searchLocationId : searchLocationId.value}
                    searchDestinationId={searchDestinationId.value}
                    billablePaxCount={billablePaxCount}
                />
                <ViewMore
                    isViewMoreOpen={isViewMoreOpen}
                    closeViewMore={this.closeViewMoreModal}
                    moreData={getMoreData}
                    filterStatus={this.filterStatus}
                    filterUsers={this.filterUsers}
                />
                <EditPdm
                    user={this.props.user}
                    formError={formError}
                    error={error}
                    airlineError={airlineError}
                    flightError={flightError}
                    locationError={locationError}
                    destinationError={destinationError}
                    passengerCountError={passengerCountError}
                    billablePaxError={billablePaxError}
                    handleDateChange={this.handleDateChange}
                    closeEditModal={this.closeEditModal}
                    isEditModalOpen={isEditModalOpen}
                    handleUpdate={this.handleUpdate}
                    newAirlineId={newAirlineId}
                    flightNumbers={editFlightNumbers}
                    newFlightNumber={newFlightNumber}
                    newLocationId={newLocationId}
                    newDestinationId={newDestinationId}
                    locationData={locationData}
                    destinationData={destinationData}
                    newPassengerCount={newPassengerCount}
                    newBillablePaxCount={newBillablePaxCount}
                    pendingPdmId={pendingPdmId}
                    airlines={airlines}
                    newFlightDate={newFlightDate}
                    selectChange={this.selectChange}
                    billablePaxError2={billablePaxError2}
                    disabled={requesting}
                    reactSelectChange={this.handleReactSelectChange}
                />
                <GridItem xs={12} sm={12} md={12}>
                    <Card>
                        <CardHeader color="success">
                            <h4 className={classes.cardTitleWhite}>PDM Data</h4>
                            <p className={classes.cardCategoryWhite}>
                                Here is a table for PDM Data
                            </p>
                        </CardHeader>
                        <CardBody>
                            {
                                !requestingPdm && totalCount !== 0
                                &&
                                <PdmTable
                                    user={user}
                                    pdmData={pdmData}
                                    currentPage={currentPage}
                                    pageSize={pageSize}
                                    fetchPdmData={this.searchPdm}
                                    totalCount={totalCount}
                                    filterAirlines={this.filterAirlines}
                                    filterStatus={this.filterStatus}
                                    openEditModal={this.openEditModal}
                                    openViewMore={this.openViewMoreModal}

                                />
                            }
                            {
                                !requestingPdm && totalCount === 0
                                && <EmptyRecord message={'No PDM Record'} />
                            }
                        </CardBody>
                        {
                            !requestingPdm && totalCount !== 0 &&
                            <CardFooter chart>
                                <div>
                                    <Button type="button" color="info" onClick={() => this.downloadPdm('pdf')} disabled={requesting}>
                                        <DownloadIcon />
                                        Download PDF
                              </Button>
                                    <Button type="button" color="primary" onClick={() => this.downloadPdm('excel')} disabled={requesting}>
                                        <DownloadIcon />
                                        Download EXCEL
                                </Button>
                                </div>
                            </CardFooter>
                        }

                    </Card>
                </GridItem>
            </div>
        )
    }
}

function mapStateToProps(state, ownProps) {
    const { airports, users, user, airlines, alert, requesting, modal } = state;
    return {
        airports,
        users,
        user,
        airlines,
        alert,
        requesting,
        modal
    };
}

export default connect(mapStateToProps)(withMobileDialog()(withStyles(dashboardStyle)(Pdm)))


// WEBPACK FOOTER //
// ./src/views/PDM/Index.jsx